import { sepolia } from './sepolia';
import { mainnet } from './mainnet';
export const networks = { sepolia, mainnet };
